'use client'

/**
 * useUserAssignment — thin wrapper around UserContext.
 *
 * Previously: each caller made its own Supabase round-trip.
 * Now: reads from the single UserContext fetch done at app mount.
 *
 * Shape is identical to the old hook — zero page changes required.
 */

import { useUser, type UserIncidentUnit } from '@/contexts/UserContext'
import type { Employee } from '@/lib/services/employees'

export type UserAssignment = {
  user: { id: string; email?: string } | null
  employee: Employee | null
  incidentUnit: UserIncidentUnit | null
  unit: { id: string; name: string } | null
  incident: { id: string; name: string } | null
  loading: boolean
}

export function useUserAssignment(): UserAssignment {
  const { user, employee, incidentUnit, unit, incident, loading } = useUser()
  return { user, employee, incidentUnit, unit, incident, loading }
}
